<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <projects-table-guest title="Visiteurs"></projects-table-guest>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  import ProjectsTableGuest from './Tables/ProjectsTableGuest'
  export default {
    name: 'tables',
    components: {
      ProjectsTableGuest
    }
  };
</script>
<style></style>
